import React = require('react');
import ReactDOM = require('react-dom');
import {
  StyledTable,
  StyledTableRow,
  StyledTableCell,
  StyledTableCaption,
  StyledTableRowGroup,
  StyledTableHeader,
  StyledShortCode,
  StyledCopyButton,
  StyledTableIntro
} from './styled';
import { SharePointHome } from '../services/SharePointHome';
import { ValidatableTextInput } from './validables';

export interface IEnv {
  nonce: string;
  wpAjaxAdminUrl: string;
  props: IEnvProps;
}

export interface IEnvProps {
  resource?: string;
  pageSize?: string;
  home?: string;
}

export interface IConfiguratorProps {
  env: IEnv;
}

export interface IConfiguratorState {
  sharePointHome: string;
  sharePointHomeError: boolean;
  scriptSrc: string;
  pageSize: number;
}

export class Configurator extends React.Component<
  IConfiguratorProps,
  IConfiguratorState
> {
  public constructor(props: IConfiguratorProps) {
    super(props);
    this.state = {
      sharePointHome: '',
      sharePointHomeError: false,
      scriptSrc: this.currentScriptSrc('cfg.js').replace('cfg.js', 'cbs.js'),
      pageSize: 10
    };
    SharePointHome.get(props.env)
      .then((response: any) => {
        if (response && response.data && response.data.webUrl) {
          this.setState({
            sharePointHome: response.data.webUrl,
            sharePointHomeError: false
          });
        } else {
          if (response instanceof Error) {
            throw response;
          }
        }
      })
      .catch((error: Error) => {
        const message = `Could not request SharePoint Home from Microsoft Graph. Reason: ${
          error.message
        }`;
        alert(message);
        this.setState({ sharePointHomeError: true });
      });
  }

  public render(): React.ReactElement<IConfiguratorProps> {
    return (
      <StyledTable>
        <StyledTableCaption>
          <StyledTableHeader>
            Pintra FX shortcode generator for WPO365 SharePoint Online
          </StyledTableHeader>
          <StyledTableIntro>
            To get started with integrating SharePoint Online search in your
            WordPress intranet you can simply follow these four steps described
            in our online documentation:
            <ul>
              <li>
                <a href="https://www.wpo365.com/wpo365-spo-prerequisites/">
                  Prerequisites
                </a>
              </li>
              <li>
                <a href="https://www.wpo365.com/wpo365-spo-installation/">
                  Installation
                </a>
              </li>
              <li>
                <a href="https://www.wpo365.com/wpo365-spo-configuration/">
                  Configuration
                </a>
              </li>
              <li>Shortcode</li>
            </ul>
            To create the shortcode you can use this generator. Simply configure
            the options and copy the shortcode to the clipboard. Then all you
            need to do is to add the shortcode to a page and you're ready!
          </StyledTableIntro>
        </StyledTableCaption>
        <StyledTableRowGroup>
          <StyledTableRow>
            <StyledTableCell>Your SharePoint Home URL</StyledTableCell>
            <StyledTableCell>
              <ValidatableTextInput
                isValid={(oldValue: any, newValue: any) => {
                  return (newValue as string).indexOf('https://') === 0;
                }}
                onValid={(newValue: any) => {
                  console.log(newValue);
                  return;
                  // this.setState({ sharePointHome: newValue as string })
                }}
                errorMessage={
                  'SharePoint Home must start with https e.g. https://your-tenant.sharepoint.com'
                }
                defaultValue={'https://'}
                value={this.state.sharePointHome}
                disabled={!this.state.sharePointHomeError}
              />
            </StyledTableCell>
          </StyledTableRow>
          <StyledTableRow>
            <StyledTableCell>Results per page</StyledTableCell>
            <StyledTableCell>
              <ValidatableTextInput
                isValid={(oldValue: any, newValue: any) => {
                  const newValueAsInt = parseInt(newValue);
                  return (
                    (newValue as string) === newValueAsInt.toString() &&
                    newValueAsInt > 0 &&
                    newValueAsInt < 50
                  );
                }}
                onValid={(newValue: any) =>
                  this.setState({ pageSize: parseInt(newValue) })
                }
                errorMessage={
                  'pageSize must be number greater than 0 and smaller than 50'
                }
                defaultValue={'10'}
              />
            </StyledTableCell>
          </StyledTableRow>
          <StyledTableRow>
            <StyledTableCell>Shortcode:</StyledTableCell>
            <StyledTableCell>
              <StyledShortCode
                readOnly={true}
                value={`[pintra props="resource,${
                  this.state.sharePointHome
                };pageSize,${this.state.pageSize};home,${
                  this.state.sharePointHome
                }" script_url="${this.state.scriptSrc}"]`}
                className={'pintra-fx-shortcode'}
              />
            </StyledTableCell>
          </StyledTableRow>
          <StyledTableRow>
            <StyledTableCell />
            <StyledTableCell>
              <StyledCopyButton onClick={this.copyShortcode}>
                Copy to clipboard
              </StyledCopyButton>
            </StyledTableCell>
          </StyledTableRow>
          <StyledTableRow>
            {/* Footer */}
            <StyledTableCell />
            <StyledTableCell />
          </StyledTableRow>
        </StyledTableRowGroup>
      </StyledTable>
    );
  }

  private currentScriptSrc = (scriptName: string): string | null => {
    const scriptTags = document.getElementsByTagName('script');
    for (let i = scriptTags.length - 1; i >= 0; i--) {
      if (scriptTags[i].src.indexOf(scriptName) > -1) {
        return scriptTags[i].src;
      }
    }
    return null;
  };

  private copyShortcode = () => {
    (document.getElementsByClassName(
      'pintra-fx-shortcode'
    )[0] as HTMLTextAreaElement).select();
    document.execCommand('copy');
  };
}
